import { styled } from "@mui/material";
import { TruncateList as TidalTruncateList } from "../../layout/TruncateList/index.js";
import { actionBarName } from "../classes.js";
const TruncateList = styled(TidalTruncateList, {
  name: actionBarName,
  overridesResolver: (_, styles) => styles.truncateList,
  slot: "TruncateList"
})(() => ({}));
export {
  TruncateList
};
//# sourceMappingURL=TruncateList.js.map
